const becomeSellerBn = {
	breadcrumbs: {
		home: 'হোম',
		becomeSeller: 'বিক্রেতা হিসেবে যোগ দিন'
	},
	hero: {
		title: 'বিক্রেতা হিসেবে যোগ দিন',
		subtitle: 'গ্রামীণ বাজারের সাথে আপনার ব্যবসা বাড়ান এবং লক্ষ লক্ষ গ্রাহকের কাছে পৌঁছান',
		cta: 'এখনই শুরু করুন'
	},
	stats: [
		{ value: '৫০,০০০+', label: 'সক্রিয় বিক্রেতা' },
		{ value: '৯৮%', label: 'সময়মতো পেমেন্ট' },
		{ value: '৩০০%', label: 'গড় বিক্রয় বৃদ্ধি' },
		{ value: '৪.৮/৫', label: 'বিক্রেতা সন্তুষ্টি' }
	],
	benefits: {
		title: 'বিক্রেতা হওয়ার সুবিধা',
		items: [
			{ title: 'বিক্রয় বৃদ্ধি', description: 'আমাদের ১০ লক্ষ+ গ্রাহকের কাছে আপনার পণ্য পৌঁছান' },
			{ title: 'বেশি আয়', description: 'প্রতিযোগিতামূলক কমিশন রেট এবং দ্রুত পেমেন্ট' },
			{ title: '২৪/৭ সাপোর্ট', description: 'আমাদের ডেডিকেটেড সেলার সাপোর্ট টিম সবসময় আপনার পাশে' },
			{ title: 'নিরাপদ লেনদেন', description: 'সম্পূর্ণ নিরাপদ এবং স্বচ্ছ পেমেন্ট সিস্টেম' },
			{ title: 'দ্রুত সেটআপ', description: 'মাত্র ২৪ ঘন্টায় আপনার দোকান চালু করুন' },
			{ title: 'বিক্রয় বিশ্লেষণ', description: 'বিস্তারিত রিপোর্ট এবং বিক্রয় ট্র্যাকিং সুবিধা' }
		]
	},
	steps: {
		title: 'কিভাবে শুরু করবেন',
		stepNumbers: ['১', '২', '৩'],
		items: [
			{ title: 'রেজিস্ট্রেশন', description: 'আপনার ব্যক্তিগত ও ব্যবসায়িক তথ্য দিয়ে রেজিস্ট্রেশন করুন' },
			{ title: 'যাচাইকরণ', description: 'আমাদের টিম আপনার তথ্য যাচাই করে ২৪ ঘন্টার মধ্যে অনুমোদন দেবে' },
			{ title: 'বিক্রয় শুরু', description: 'পণ্য আপলোড করুন এবং বিক্রয় শুরু করুন' }
		]
	},
	  cta: {
    title: 'আজই শুরু করুন আপনার ডিজিটাল ব্যবসা',
    subtitle: 'গ্রামীণ বাজারের সাথে যুক্ত হয়ে আপনার ব্যবসাকে নিয়ে যান নতুন উচ্চতায়',
    button: 'বিক্রেতা হিসেবে যোগ দিন'
  },
  transformDreams: {
    title: 'গ্রামীণ বাজারের সাথে আপনার স্বপ্নের রূপান্তর',
    content: [
      'কল্পনা করুন—আপনার ব্যবসা দিনে দিনে ফুলে-ফেঁপে উঠছে। শুধু পরিচিত মুখ নয়, বরং প্রতিটি গ্রাম থেকে আসা নতুন ক্রেতারা প্রথমবারের মতো আপনাকে ও আপনার পণ্যকে খুঁজে পাচ্ছে। গ্রামীণ বাজারে, আপনার পণ্য মানুষের দৈনন্দিন জীবনের অংশ হয়ে যায়—তাদের কাছে পৌঁছে যায়, যারা আগে কখনও কোনো বাজারে কেনাকাটা করেনি।',
      'আমাদের শক্তিশালী প্রচারণা গভীর গ্রাম-গঞ্জ পর্যন্ত পৌঁছে দেয়, মানুষকে একত্র করে—প্রতিবেশী, বন্ধু ও পরিচিতজন সবাই মিলে স্থানীয় বিক্রেতাদের (আপনার মতো) সমর্থন করতে এগিয়ে আসে। আমাদের সাম্প্রতিক জরিপে দেখা গেছে এক অবিশ্বাস্য তথ্য: প্রায় ৩০% ক্রেতা একেবারেই নতুন, যারা আগে কখনও কোনো মার্কেটপ্লেসে কেনাকাটা করেননি কিন্তু এখন প্রস্তুত, আপনাদের কাছ থেকে কিনতে।',
      'এটি এমন এক সুযোগ যা আগে কখনও পাননি—তাদের সঙ্গে সম্পর্ক গড়ার, তাদের গল্পে স্থান পাওয়ার, আর আপনার বিক্রি ৫০% থেকে ১০০% বা তার বেশি বাড়ানোর। আমাদের সাথে যোগ দিন—গ্রামীণ বাজার শুধু একটি প্ল্যাটফর্ম নয়, বরং একটি আন্দোলন।',
      'চলুন একসাথে আশা, সুযোগ আর সমৃদ্ধি পৌঁছে দিই আপনার পরিবারে, আপনার গ্রামে, আর আপনার স্বপ্নে। গ্রাহকরা অপেক্ষা করছে—এবার আপনার জ্বলে উঠার সময়।'
    ]
  }
};

export default becomeSellerBn;


